import ArticuloForm from '../../spa/articulo/articulo';

export default {
    path: '/articulo/:idArticulo?',
    name: 'articulo',
    component: ArticuloForm
};


// WEBPACK FOOTER //
// ./src/config/router/articulo.js